import { ReactElement } from 'react';
import { useIsMobile } from '@hooks';
import Modal from '@components/Modal';
import ForgotPasswordForm from '@components/Auth/ForgotPasswordForm';
import { View } from '@components/Auth/types';
import s from './ForgotPasswordModal.module.scss';

type Props = {
  creatorSlug?: string;
  userEmail: string;
  onClose: () => void;
  onChangeView: (view: View) => void;
};

const ForgotPasswordModal = ({ creatorSlug, onClose, onChangeView, userEmail }: Props): ReactElement => {
  const isMobile = useIsMobile();
  return (
    <Modal
      hideBottomInset
      isPinnedToBottom={isMobile}
      title='Reset Password'
      onClose={onClose}
      hasCloseOnActions={false}
    >
      <div className={s.forgotPasswordPage}>
        <ForgotPasswordForm creatorSlug={creatorSlug} userEmail={userEmail} onChangeView={onChangeView}/>
      </div>
    </Modal>
  );
};

export default ForgotPasswordModal;
